<template>
  <div class="flex-1">
    <ul class="flex flex-col divide-y divide-gray-200 h-full">
      <li class="px-3 py-2">
        <MessageForm v-if="isParticipant" :conversation="conversation" @created="fetchMessages" />
        <JoinConversationForm v-else :conversation="conversation" />
      </li>
      <li class="pl-3 flex-1 bg-gray-50">
        <div class="py-2 pr-3 lg:h-0 lg:min-h-full overflow-auto fancy-scrollbar">
          <div class="text-center p-2">
            <BaseButton primary small outline :disabled="loading" @click="fetchMessages">
              Refresh
            </BaseButton>
          </div>
          <Messages :messages="messages" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import JoinConversationForm from './JoinConversationForm.vue';
import MessageForm from './MessageForm.vue';
import Messages from './Messages.vue';

export default {
  components: {
    MessageForm,
    Messages,
    JoinConversationForm,
  },
  props: {
    conversation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resolved: false,
      rejected: false,
    };
  },
  computed: {
    participants() {
      if (!this.conversation?.participants) {
        return [];
      }

      return this.conversation.participants.map(
        (participantId) => this.$store.state.entities.conversationParticipants.byId[participantId]
      );
    },
    participables() {
      return this.participants.map(
        ({ participable }) => this.$store.state.entities[participable.schema].byId[participable.id]
      );
    },
    isParticipant() {
      return this.participables.find((participable) => participable.id === this.$user.id);
    },
    messages() {
      return this.$store.getters['ui/conversationMessages/itemsByParent'](this.conversation.id);
    },
  },
  created() {
    this.fetchMessages();
  },
  destroyed() {
    this.$store.commit('ui/conversationMessages/setIdsByParent', {
      parentId: this.conversation.id,
      ids: [],
    });
  },
  methods: {
    setLoading(loading = true) {
      this.loading = Boolean(loading);
    },
    setResolved(resolved = true) {
      this.resolved = Boolean(resolved);
    },
    setRejected(rejected = true) {
      this.rejected = Boolean(rejected);
    },
    async fetchMessages() {
      try {
        this.setLoading();
        await this.$store.dispatch('ui/conversationMessages/load', {
          conversationId: this.conversation.id,
          query: {
            include: 'author,thirdPartyService,messageThirdPartyServices',
          },
        });
        this.setResolved();
      } catch (error) {
        this.setRejected();
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
